import { render, staticRenderFns } from "./Step2Mobile.vue?vue&type=template&id=2c97d1ed&scoped=true&"
import script from "./Step2Mobile.vue?vue&type=script&lang=js&"
export * from "./Step2Mobile.vue?vue&type=script&lang=js&"
import style0 from "./Step2Mobile.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Step2Mobile.vue?vue&type=style&index=1&id=2c97d1ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c97d1ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c97d1ed')) {
      api.createRecord('2c97d1ed', component.options)
    } else {
      api.reload('2c97d1ed', component.options)
    }
    module.hot.accept("./Step2Mobile.vue?vue&type=template&id=2c97d1ed&scoped=true&", function () {
      api.rerender('2c97d1ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/Step2Mobile/Step2Mobile.vue"
export default component.exports